// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

/** Play (media). */
const icon: IconData = {
  id: "play",
  name: "Play",
  category: "media",
  styles: {
    rounded: {
      svg: '<path d="M8 17.18V6.83Q8 6.41 8.3 6.12T9 5.83Q9.12 5.83 9.26 5.87T9.52 5.98L17.67 11.15Q17.9 11.3 18.01 11.53T18.12 12 18.01 12.47 17.67 12.85L9.52 18.02Q9.4 18.09 9.26 18.13T9 18.18Q8.6 18.18 8.3 17.89T8 17.18"/>',
    },
    sharp: { svg: '<path d="M8 19V5L19 12Z"/>' },
    outline: {
      svg: '<path d="M8 17.18V6.83Q8 6.41 8.3 6.12T9 5.83Q9.12 5.83 9.26 5.87T9.52 5.98L17.67 11.15Q17.9 11.3 18.01 11.53T18.12 12 18.01 12.47 17.67 12.85L9.52 18.02Q9.4 18.09 9.26 18.13T9 18.18Q8.6 18.18 8.3 17.89T8 17.18M10 15.36L15.25 12 10 8.65Z"/>',
    },
    duotone: {
      svg: '<g opacity=".32"><path d="M9 5.83L9.52 5.98 17.67 11.15 18.01 11.53 18.12 12 18.01 12.47 17.67 12.85 9.52 18.02 9 18.18 8.63 18.11 8.3 17.89 8.07 17.57 8 17.18V6.83L8.07 6.44 8.3 6.12 8.63 5.9Z"/></g><path d="M8 17.18V6.83Q8 6.41 8.3 6.12T9 5.83Q9.12 5.83 9.26 5.87T9.52 5.98L17.67 11.15Q17.9 11.3 18.01 11.53T18.12 12 18.01 12.47 17.67 12.85L9.52 18.02Q9.4 18.09 9.26 18.13T9 18.18Q8.6 18.18 8.3 17.89T8 17.18M10 15.36L15.25 12 10 8.65Z"/>',
    },
  },
  animation: () => import("../animations/play.js"),
};

export default icon;
